import { css } from '@emotion/core';
import MediaQueries from '../../../../../styles/Grid/MediaQueries';

export const containerCss = css({
  width: '100%',
  position: 'absolute',
  marginTop: -61,
});

export const imageLeftContainer = css({
  width: '100%',
  minHeight: 647,
  position: 'absolute',
  top: 0,
  left: 100,
});

export const imageLeftCss = css({
  width: 843,
  height: 647,
  position: 'absolute',
  right: 0,
});

export const imageRightTopCss = css({
  width: 367,
  height: 244,
  position: 'absolute',
  top: 0,
  left: 0,
});

export const imageRightBottomCss = css({
  width: 414,
  height: 288,
});

export const imageRightNextContainer = css({
  left: 0,
  minHeight: 244,
  overflow: 'visible',
  position: 'absolute',
  top: 0,
  width: '100%',
});

export const bleedImageRightDimentionCss = css({
  minHeight: 172,
  marginTop: 186,
  [MediaQueries.xl]: {
    minHeight: 192,
    marginTop: 166,
  },
});

export const imageRightContainer = css({
  width: '100%',
  minHeight: 210,
  [MediaQueries.lg]: {
    minHeight: 288,
    overflow: 'hidden',
  },
});
